import { useConstCallback } from '@uifabric/react-hooks';
import * as formik from 'formik';
import * as fabric from 'office-ui-fabric-react';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../../../../api/generated';
import { KendoLoading } from '../../../../../components';

interface ITerminalColorsForm {
    primaryColor: string | null;
    secondaryColor: string | null;
    windowTitleColor: string | null;
    modalBackgroundColor: string | null;
}

const labelStyles: fabric.ILabelStyles = {
    root: {
        textAlign: 'left'
    }
};

const GeneralSettingsDesignTerminal = () => {
    const [colors, setColors] = useState<null | ITerminalColorsForm>(null);

    const updateColor = useConstCallback((hexColor: string, fieldName: string, setFieldValue: Function) => setFieldValue(fieldName, `#${hexColor}`));

    const fetchData = async () => {
        const resp = await api.design.getGeneralTerminalsDesign();
        setColors(resp);
    };
    useEffect(() => {
        fetchData();
    }, []);

    const handleSubmit = async (values: ITerminalColorsForm, formikActions: formik.FormikHelpers<ITerminalColorsForm>) => {
        try {
            await api.design.saveGeneralTerminalsDesign(values);
            setColors(null);
            await fetchData();
            toast.success('Informacija sėkmingai išsaugota');
            formikActions.resetForm();
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };

    const handleReset = async (resetForm: Function) => {
        try {
            await api.design.resetGeneralTerminalsDesignSettings();
            setColors(null);
            await fetchData();
            toast.success('Terminalo dizainas nustatytas į pradinius nustatymus');
            resetForm();
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };
    return (
        <div className="ms-Grid" dir="ltr">
            {!colors && <KendoLoading />}
            {colors && (
                <formik.Formik
                    initialValues={{ ...colors }}
                    onSubmit={handleSubmit}
                    render={(props) => (
                        <formik.Form>
                            <div className="ms-Grid-row" style={{ textAlign: 'right', marginTop: '10px' }}>
                                <fabric.DefaultButton onClick={() => handleReset(props.resetForm)} text="Atkurti pradinius nustatymus" />
                            </div>
                            <div className="ms-Grid-row">
                                <fabric.Text style={{ fontWeight: 'lighter' }} variant="large">
                                    Spalvos
                                </fabric.Text>
                                <fabric.Separator />
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-md4">
                                    <fabric.Label styles={labelStyles}>Pirminė spalva</fabric.Label>
                                    <formik.Field
                                        name="primaryColor"
                                        render={({ field, form }: formik.FieldProps<string>) => (
                                            <fabric.ColorPicker
                                                color={field.value}
                                                alphaSliderHidden={true}
                                                onChange={(ev: any, colorObj: fabric.IColor) =>
                                                    updateColor(colorObj.hex, field.name, form.setFieldValue)
                                                }
                                                showPreview={true}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-md4">
                                    <fabric.Label styles={labelStyles}>Antrinė spalva</fabric.Label>
                                    <formik.Field
                                        name="secondaryColor"
                                        render={({ field, form }: formik.FieldProps<string>) => (
                                            <fabric.ColorPicker
                                                color={field.value}
                                                alphaSliderHidden={true}
                                                onChange={(ev: any, colorObj: fabric.IColor) =>
                                                    updateColor(colorObj.hex, field.name, form.setFieldValue)
                                                }
                                                showPreview={true}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-md4">
                                    <fabric.Label styles={labelStyles}>Lango pavadinimo spalva</fabric.Label>
                                    <formik.Field
                                        name="windowTitleColor"
                                        render={({ field, form }: formik.FieldProps<string>) => (
                                            <fabric.ColorPicker
                                                color={field.value}
                                                alphaSliderHidden={true}
                                                onChange={(ev: any, colorObj: fabric.IColor) =>
                                                    updateColor(colorObj.hex, field.name, form.setFieldValue)
                                                }
                                                showPreview={true}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="ms-Grid-row" dir="ltr">
                                <div className="ms-Grid-col ms-md4">
                                    <fabric.Label styles={labelStyles}>Iššokančio lango fono spalva</fabric.Label>
                                    <formik.Field
                                        name="modalBackgroundColor"
                                        render={({ field, form }: formik.FieldProps<string>) => (
                                            <fabric.ColorPicker
                                                color={field.value}
                                                alphaSliderHidden={true}
                                                onChange={(ev: any, colorObj: fabric.IColor) =>
                                                    updateColor(colorObj.hex, field.name, form.setFieldValue)
                                                }
                                                showPreview={true}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="ms-Grid-row">
                                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                    <fabric.PrimaryButton
                                        className="ms-slideRightIn40 ms-textAlignRight"
                                        text="Išsaugoti"
                                        disabled={props.isSubmitting || !props.isValid || !props.dirty}
                                        type="submit"
                                    />
                                </div>
                            </div>
                        </formik.Form>
                    )}
                />
            )}
        </div>
    );
};

export default GeneralSettingsDesignTerminal;
